import { Badge } from '@jpg/design-system'
import { useNavigation } from 'react-router'

export function NavigationFeedback() {
  const navigation = useNavigation()
  if (navigation.state === 'idle') return null
  const saving = navigation.formMethod && navigation.formMethod.toUpperCase() !== 'GET'
  return (
    <div role="status" aria-live="polite" className="pointer-events-none fixed right-4 top-4 z-50">
      <Badge variant="navy" size="md">{saving ? 'Saving…' : 'Loading…'}</Badge>
    </div>
  )
}
